import {AssistanceDocument} from './assistance-document';

export class Assistance {
  id: number | null;
  ticketCrmId: string | null;
  label: string;
  creationDate: Date;
  modificationDate: Date;
  category: string;
  subCategory: string;
  status: string;
  importance: string;
  published: boolean;
  internal: boolean;
  publicationDate: any;
  documents: Array<AssistanceDocument>;
  solution: string;
  read: boolean;


  constructor(id: number | null, ticketCrmId: string | null,
              label: string, creationDate: Date,
              modificationDate: Date, category: string,
              subCategory: string, status: string,
              importance: string, published: boolean,
              internal: boolean, publicationDate: any,
              documents: Array<AssistanceDocument>,
              solution: string, read: boolean) {
    this.id = id;
    this.ticketCrmId = ticketCrmId;
    this.label = label;
    this.creationDate = creationDate;
    this.modificationDate = modificationDate;
    this.category = category;
    this.subCategory = subCategory;
    this.status = status;
    this.importance = importance;
    this.published = published;
    this.internal = internal;
    this.publicationDate = publicationDate;
    this.documents = documents;
    this.solution = solution;
    this.read = read;
  }
}
